import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/landing/dist/finance/@section2/index.js");
